import { useNls } from '../../nls/nlsProvider'
import type { ResourceRiskItem } from '../../types/resource'
import { Pressable } from '../Common/Pressable'
import { ResourceBadges } from './ResourceBadges'
import './resources.css'

type Props = {
  items: ResourceRiskItem[]
  onOpenItem?: (itemId: string) => void
  maxItems?: number
}

export const ResourceReadinessPanel = ({ items, onOpenItem, maxItems = 8 }: Props) => {
  const { t } = useNls()
  const visible = items.slice(0, maxItems)
  return (
    <section className="resourceReadinessPanel" aria-label={t('NLSResourcesReadinessTitle')}>
      <header>
        <div>
          <span className="settingsEyebrow">{t('NLSResourcesReadinessTitle')}</span>
          <h2>{t('NLSResourcesReadinessTitle')}</h2>
        </div>
        <strong>{items.length}</strong>
      </header>
      {visible.length === 0 ? (
        <p className="resourceReadinessEmpty">{t('NLSResourcesReadinessEmpty')}</p>
      ) : (
        <div className="resourceReadinessList">
          {visible.map((item) => {
            const content = (
              <>
                <span>
                  <strong>{item.title}</strong>
                  {item.ownerTitle && <small>{item.ownerTitle}</small>}
                </span>
                <ResourceBadges signals={item.signals} compact />
              </>
            )
            return onOpenItem ? (
              <Pressable key={item.id} type="button" className="resourceReadinessRow" onClick={() => onOpenItem(item.id)}>
                {content}
              </Pressable>
            ) : (
              <div key={item.id} className="resourceReadinessRow">
                {content}
              </div>
            )
          })}
        </div>
      )}
    </section>
  )
}
